import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Music(props: StickerArtProps) {
  return (
    <StickerFrame background="#c026d3" {...props}>
      <ellipse cx="22" cy="44" rx="6.5" ry="5" fill="#ffffff" transform="rotate(-20 22 44)" />
      <ellipse cx="42" cy="39" rx="6.5" ry="5" fill="#ffffff" transform="rotate(-20 42 39)" />
      <rect x="26" y="20" width="3.5" height="25" fill="#ffffff" />
      <rect x="46" y="15" width="3.5" height="25" fill="#ffffff" />
      <path d="M26 20 L49.5 14 V21 L26 27 Z" fill="#ffffff" />
    </StickerFrame>
  );
}
